import { render } from "./Gnb.vue?vue&type=template&id=1580f833&scoped=true"
import script from "./Gnb.vue?vue&type=script&lang=js"
export * from "./Gnb.vue?vue&type=script&lang=js"

import "./Gnb.scss?vue&type=style&index=0&id=1580f833&lang=scss&scoped=true"

import exportComponent from "/home/viewchat/public_html/viewchat-web-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1580f833"]])

export default __exports__